module.exports = __webpack_public_path__ + "static/img/bg-one.9f3f864.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-one.jpg
// module id = X/Us
// module chunks = 1